import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "columns is-centered",
  style: {"margin-top":"2%"}
}
const _hoisted_3 = { class: "columns is-12" }
const _hoisted_4 = { class: "is-grey-background" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "columns is-centered" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "column is-12",
    style: {"text-align":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "title is-narrow is-spaced" }, "Change Password")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "columns is-centered" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column is-12" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_7 = { class: "columns is-centered" }
const _hoisted_8 = { class: "column is-12" }
const _hoisted_9 = { class: "columns is-centered" }
const _hoisted_10 = { class: "column is-narrow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_input = _resolveComponent("o-input")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_Field = _resolveComponent("Field")!
  const _component_o_button = _resolveComponent("o-button")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      ref: "formValidator",
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Field, {
                    name: "Email",
                    modelValue: _ctx.Email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.Email) = $event))
                  }, {
                    default: _withCtx(({ field, meta, errors }) => [
                      _createVNode(_component_o_field, {
                        label: "Email",
                        variant: errors[0] ? 'danger' : '',
                        message: errors[0] ? errors[0] : ''
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_o_input, _mergeProps({
                            autocomplete: "disabled",
                            placeholder: "Email",
                            modelValue: _ctx.Email,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.Email) = $event)),
                            name: "Email"
                          }, field, {
                            type: "email",
                            maxlength: "50"
                          }), null, 16, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["variant", "message"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_o_button, {
                    variant: "info",
                    class: "is-fullwidth-mobile",
                    pack: "fas",
                    "native-type": "submit"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Submit ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}